{
	"title": "Календарь",
	"subtitle": "Расписание занятий, экзамены и повторения",
	"views": {
		"day": "День",
		"week": "Неделя",
		"month": "Месяц",
		"agenda": "Список"
	},
	"nav": {
		"prev": "Назад",
		"next": "Вперёд",
		"today": "Сегодня"
	},
	"events": {
		"addEvent": "Добавить событие",
		"newEvent": "Новое событие",
		"editEvent": "Редактировать событие",
		"studySession": "Учебная сессия",
		"exam": "Экзамен",
		"deadline": "Дедлайн",
		"lecture": "Лекция",
		"reminder": "Напоминание",
		"moreCount": "+{count} ещё",
		"dayCount": "{count, plural, one {# событие} few {# события} other {# событий}}",
		"countOne": "{count} событие",
		"countFew": "{count} события",
		"countMany": "{count} событий"
	},
	"types": {
		"lesson": "Урок",
		"exam": "Экзамен",
		"review": "Повторение",
		"custom": "Произвольное"
	},
	"fields": {
		"title": "Название",
		"titlePlaceholder": "Например, ЕГЭ Биология",
		"description": "Описание",
		"descriptionPlaceholder": "Опционально",
		"type": "Тип",
		"allDay": "Весь день",
		"start": "Начало",
		"end": "Окончание",
		"timezone": "Часовой пояс",
		"location": "Место",
		"locationPlaceholder": "Например, Школа №42",
		"recurrence": "Повторение",
		"reminder": "Напоминание",
		"examPreset": "Экзамен"
	},
	"recurrence": {
		"none": "Не повторять",
		"daily": "Ежедневно",
		"weekly": "Еженедельно",
		"monthly": "Ежемесячно",
		"yearly": "Ежегодно",
		"weekdays": "По будням"
	},
	"reminders": {
		"label": "Напоминания",
		"none": "Без напоминания",
		"min5": "За 5 минут",
		"min10": "За 10 минут",
		"min30": "За 30 минут",
		"hour1": "За 1 час",
		"hour2": "За 2 часа",
		"day1": "За 1 день",
		"minutesBefore": "За {count} мин",
		"hoursBefore": "За {count} ч",
		"daysBefore": "За {count} дн"
	},
	"today": "Сегодня",
	"thisWeek": "Эта неделя",
	"noEvents": "На сегодня событий нет",
	"examIn": "До экзамена {days} дней",
	"weekRange": "{from} — {to}",
	"month": {
		"header": "{month} {year}",
		"empty": "На этом месяце пусто",
		"addOne": "Добавить событие"
	},
	"week": {
		"now": "Сейчас",
		"empty": "Эта неделя пуста",
		"allDay": "Весь день"
	},
	"day": {
		"empty": "На этот день событий нет"
	},
	"dialog": {
		"create": "Новое событие",
		"edit": "Редактировать событие",
		"view": "Событие",
		"save": "Сохранить",
		"cancel": "Отмена",
		"delete": "Удалить",
		"deleteConfirm": "Удалить событие?",
		"deleteConfirmDescription": "Событие попадёт в корзину на 30 дней.",
		"validation": {
			"titleRequired": "Введите название",
			"endAfterStart": "Окончание должно быть позже начала"
		}
	},
	"errors": {
		"loadFailed": "Не удалось загрузить календарь",
		"retry": "Повторить"
	},
	"dayNamesShort": ["Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс"],
	"dayNamesLong": [
		"Понедельник",
		"Вторник",
		"Среда",
		"Четверг",
		"Пятница",
		"Суббота",
		"Воскресенье"
	],
	"monthNames": [
		"Январь",
		"Февраль",
		"Март",
		"Апрель",
		"Май",
		"Июнь",
		"Июль",
		"Август",
		"Сентябрь",
		"Октябрь",
		"Ноябрь",
		"Декабрь"
	],
	"examPicker": {
		"title": "Дата экзамена",
		"set": "Установить дату",
		"edit": "Изменить дату"
	}
}
